import { ConfigurationTab } from '../interfaces/Configuration/Configuration'

export const configurationTab: ConfigurationTab[] = [
  {
    id: 1,
    name: 'Parámetros'
  },
  {
    id: 2,
    name: 'Tipos de Proceso'
  }
]

export const EnumConfigurationTab = {
  PARAMETROS: 1,
  TIPOS_DE_PROCESO: 2
}
